import { UpdatePatientById } from 'domain/usecases/patient/update-patient-by-id'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteUpdatePatientById implements UpdatePatientById {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  update(params: UpdatePatientById.Params): Promise<UpdatePatientById.Model> {
    return this.patientRepository.updatePatientById(params)
  }
}
